export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/home/runner/work/hub/hub/frontend/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('/home/runner/work/hub/hub/frontend/src/pages/[...path].vue'),
    /* no children */
  },
  {
    path: '/callback',
    name: '/callback',
    component: () => import('/home/runner/work/hub/hub/frontend/src/pages/callback.vue'),
    /* no children */
  },
  {
    path: '/client_list',
    name: '/client_list',
    component: () => import('/home/runner/work/hub/hub/frontend/src/pages/client_list.vue'),
    /* no children */
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/home/runner/work/hub/hub/frontend/src/pages/login.vue'),
    /* no children */
  },
  {
    path: '/sso',
    name: '/sso',
    component: () => import('/home/runner/work/hub/hub/frontend/src/pages/sso.vue'),
    /* no children */
  }
]
